import { render } from "./FormInputCvrField.vue?vue&type=template&id=e40b4230"
import script from "./FormInputCvrField.vue?vue&type=script&lang=js"
export * from "./FormInputCvrField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__